/* eslint-disable import/prefer-default-export */
export const FETCH_STOCKS = 'stock-data/Redux/FETCH_STOCKS';
export const FETCH_PROFILE = 'stock-data/Redux/FETCH_PROFILE';
export const SEARCH_STOCKS = 'stock-data/Redux/SEARCH_STOCKS';
